
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';


import { ServiceBase } from '@app/services/base.service';
import { Documento } from '@app/models/documento.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DocumentoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(documento: Documento): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/documento', documento).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/documento/${id}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/documento/${id}`);
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/documento/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
